import * as Types from '../types-api.generated';

import { UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldDropsVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  status?: Types.InputMaybe<Types.ApiDropStatus>;
  accountAddress?: Types.InputMaybe<Types.Scalars['ID']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiWorldDrops = { worldDrops: { dropCounts: { scheduledCount: number, openCount: number, mintedOutCount: number, endedCount: number }, drops: { totalItems: number, page: number, totalPages: number, items: Array<{ chainId: ChainId, id: string, name: string, mintPrice: number | null, slug: string, nftCount: number, earlyAccessStartTime: string | null, generalAvailabilityStartTime: string | null, contractType: Types.ApiContractType, isRevealed: boolean | null, contractAddress: Address, saleType: Types.ApiCollectionSaleType | null, clearingPrice: number | null, status: Types.ApiDropAvailabilityStatus, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null }> } } };



export const ApiWorldDropsDocument = /*#__PURE__*/ `
    query WorldDrops($id: Int!, $status: DropStatus, $accountAddress: ID, $page: Int, $perPage: Int) {
  worldDrops: dropsByExhibition(
    exhibitionId: $id
    status: $status
    accountAddress: $accountAddress
    page: $page
    perPage: $perPage
  ) {
    dropCounts {
      scheduledCount
      openCount
      mintedOutCount
      endedCount
    }
    drops {
      totalItems
      page
      totalPages
      items {
        chainId
        id
        name
        status: availabilityStatus
        mintPrice
        slug
        nftCount
        earlyAccessStartTime
        generalAvailabilityStartTime
        contractType
        isRevealed
        contractAddress
        saleType
        clearingPrice
        creator {
          ...UserLightFragment
        }
        media {
          ...MediaFragment
        }
        saleConfiguration {
          ...DropSaleConfigurationFragment
        }
      }
    }
  }
}
    ${UserLightFragment}
${MediaFragment}
${DropSaleConfigurationFragment}`;

export const useWorldDrops = <
      TData = ApiWorldDrops,
      TError = ClientError
    >(
      variables: ApiWorldDropsVariables,
      options?: Omit<UseQueryOptions<ApiWorldDrops, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldDrops, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldDrops, TError, TData>(
      {
    queryKey: ['WorldDrops', variables],
    queryFn: apiFetcher<ApiWorldDrops, ApiWorldDropsVariables>(ApiWorldDropsDocument, variables),
    ...options
  }
    )};

useWorldDrops.getKey = (variables: ApiWorldDropsVariables) => ['WorldDrops', variables];

export const useInfiniteWorldDrops = <
      TData = InfiniteData<ApiWorldDrops>,
      TError = ClientError
    >(
      variables: ApiWorldDropsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldDrops, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldDrops, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldDrops, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldDrops.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldDrops, ApiWorldDropsVariables>(ApiWorldDropsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldDrops.getKey = (variables: ApiWorldDropsVariables) => ['WorldDrops.infinite', variables];


useWorldDrops.fetcher = (variables: ApiWorldDropsVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldDrops, ApiWorldDropsVariables>(ApiWorldDropsDocument, variables, options);
